import styles from "./TypeSelector.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBriefcaseMedical,
  faCity,
  faCar,
  faHome,
  faBolt,
  faIndustry,
} from "@fortawesome/free-solid-svg-icons";
import {
  autoDescription,
  glassDescription,
  homeDescription,
  wcDescription,
  propertyDescription,
  liabilityDescription,
} from "../../../constants/messages";
import { formTypes } from "../../../constants/keys";

function TypeSelector({ name, selected, onSelectType }) {
  let description;
  let image;

  switch (name) {
    case formTypes.Auto:
      description = autoDescription;
      image = (
        <FontAwesomeIcon className={styles.icon} icon={faCar} size="3x" />
      );
      break;
    case formTypes.AutoGlass:
      description = glassDescription;
      image = (
        <span>
          <FontAwesomeIcon className={styles.icon} icon={faCar} size="3x" />
          <FontAwesomeIcon
            className={styles.secondIcon}
            icon={faBolt}
            size="1x"
          />
        </span>
      );
      break;
    case formTypes.Home:
      description = homeDescription;
      image = (
        <FontAwesomeIcon className={styles.icon} icon={faHome} size="3x" />
      );
      break;
    case formTypes.WorkersComp:
      description = wcDescription;
      image = (
        <FontAwesomeIcon
          className={styles.icon}
          icon={faBriefcaseMedical}
          size="3x"
        />
      );
      break;
    case formTypes.Vehicle:
      description = autoDescription;
      image = (
        <FontAwesomeIcon className={styles.icon} icon={faCar} size="3x" />
      );
      break;
    case formTypes.Property:
      description = propertyDescription;
      image = (
        <FontAwesomeIcon className={styles.icon} icon={faCity} size="3x" />
      );
      break;
    case formTypes.Liability:
      description = liabilityDescription;
      image = (
        <FontAwesomeIcon className={styles.icon} icon={faIndustry} size="3x" />
      );
      break;
    default:
      break;
  }

  return (
    <button
      className={
        selected
          ? `noselect  ${styles.container} ${styles.selectedContainer}`
          : `noselect ${styles.container}`
      }
      onClick={(event) => {
        event.preventDefault();
        onSelectType(name);
      }}
    >
      <div className={styles.titleText}>{name}</div>
      {image}
      <span className={styles.descriptionText}>{description}</span>
    </button>
  );
}

export default TypeSelector;
